import dashboard from '../views/dashboard';

export default [
  {
    path: '/dashboard',
    key: 'dashboardagent',
    component: dashboard
  }
];
